module.exports = __webpack_public_path__ + "images/avatar-s-18.0ffcd7b4.jpg";